import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// @ts-check
import React from "react";
import DefaultTrivia from "../DefaultTrivia";
import { defineTrivia } from "../defineTrivia";
import { CONTAINER_TRIVIA_BEGIN } from "../positions";
import loadable from "../../loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var HtmlToReact = loadable(function () {
  return import(/* webpackChunkName: "rich-content" */"../../HTML");
});

// NOTE: Do not forget to register your Trivia in the index.js file
// NOTE: Please keep using `defineTrivia` as it checks the proper typings

// render a trivia at the default trivia position
export default defineTrivia({
  getPosition: function getPosition() {
    return CONTAINER_TRIVIA_BEGIN;
  },
  /**
   * NOTE: the next line is not necessary, but if you have custom props, use it
   * @param {import("../defineTrivia").CommonTriviaProps & {
   *  customProp: any
   * }} props
   */
  Component: function Quote(props) {
    var content = props.content;
    var _ref = content || {},
      expert = _ref.expert,
      quote = _ref.quote;
    if (!quote) {
      return null;
    }

    // if (expert) {
    //   props = {
    //     ...props,
    //     thumbnail: `/img/experts/crop_${expert.picture}`,
    //     thumbnailTitle: expert.name,
    //     header: (
    //       <>
    //         <strong>{expert.name}, </strong> <span>{expert.profession}</span>
    //       </>
    //     ),
    //     headerBottom: true,
    //   }
    // }

    return /*#__PURE__*/_jsx(DefaultTrivia, _objectSpread(_objectSpread({}, props), {}, {
      className: "trivia-quote",
      children: /*#__PURE__*/_jsx("div", {
        className: "quote",
        children: /*#__PURE__*/_jsx(HtmlToReact, {
          preset: "basic",
          html: quote
        })
      })
    }));
  }
});
//# sourceMappingURL=Quote.js.map